<template>
  <div >
    <el-row :gutter="20">
      <el-col :span="24" style="display: flex; justify-content: end; margin-bottom: 5px;">
        <el-row style="font-size:14px; ">
          {{ this.$moment().tz('Asia/Taipei').format('YYYY/MM/DD HH:mm') }}
        </el-row>
      </el-col>
      <el-col :span="8" :xs="24">
        <el-card class="box-card">
          <div class="box-title"><i class="el-icon-first-aid-kit"></i> 健康指數:
            <span v-if="indicator">
              <span v-if="Number(displayIndicator) > 80" style="color:#4bab10">健康</span>
              <span v-else-if="Number(displayIndicator) < 60" style="color:#D8797F;">異常</span>
              <span v-else style="color:#ffb980;">良好</span>
            </span>
          </div>
          <div class="box-content">
            <v-chart 
              v-if="indicator"
              :option="indicatorChart"
              :theme="chartsTheme"
              :update-options="{ notMerge: true}" 
              style="width: 100%; height:100%"
              autoresize
            />
            <p v-else style="font-weight: bold; font-size: 16px; color:	#8E8E8E; "> 
              無資料
            </p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="16" :xs="24">
        <el-card class="box-card">
          <div class="box-title"><i class="el-icon-s-data"></i> 用水指標 </div>
          <div class="box-content">
            <div class="alarm-box-1">
              <span class="box-text"><i class="el-icon-success"></i> 正常運轉天數</span>
              <span class="box-text">
                <span class="box-small-text">上月</span> 
                <span class="box-value-text"> {{ alarmBox.goodDaysInLastMonth }}</span> 
                <span class="box-small-text"> 天</span>
              </span>
              <span class="box-text">
                <span class="box-small-text">本月</span> 
                <span class="box-value-text"> {{ alarmBox.goodDaysInThisMonth }}</span> 
                <span class="box-small-text"> 天</span>
              </span>
            </div>
            <div class="alarm-box-2">
              <span class="box-text"><i class="el-icon-warning"> 異常警示次數</i></span>
              <span class="box-text">
                <span class="box-small-text">上月</span> 
                <span class="box-value-text"> {{ alarmBox.alarmsInLastMonth }}</span> 
                <span class="box-small-text"> 次</span>
              </span>
              <span class="box-text">
                <span class="box-small-text">本月</span> 
                <span class="box-value-text"> {{ alarmBox.alarmsInThisMonth }}</span> 
                <span class="box-small-text"> 次</span>
              </span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 異常病歷 -->
    <el-row>
      <el-card class="box-card">
        <el-row>
          <div class="mb-10">
            <span class="filter-label">警示日期: </span>
            <el-date-picker
              v-model="dateRange"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="開始日期"
              end-placeholder="結束日期">
            </el-date-picker>
          </div>
          <el-col class="mb-10">
            <el-button
              size="small"
              type="primary"
              @click="getAlarmProfile()"
            >
              查詢
            </el-button>
            <el-button
              size="small"
              type="warning"
              icon="el-icon-download"
              @click="handleExport()"
            >
            匯出
            </el-button>
          </el-col>
        </el-row>
        <el-row class="mb-10">
          <el-col>
            <span class="box-title" style=" margin-left:10px"><i class="el-icon-document-copy"></i> 異常病歷：{{alarmCount}}次</span>
          </el-col>
        </el-row>
        <!-- 異常時間軸 -->
        <horizontal-timeline :alarmProfile="alarmProfile" :dateRange="dateRange" @toggle="getAlarmDetail"/>
        <alarm-list :dateRange="dateRange" ref="alarmListRef"/>
      </el-card>
    </el-row>

  </div>
</template>

<script>
import { mixins } from '@/views/common/mixins'
import HorizontalTimeline from './HorizontalTimeline.vue'
import AlarmList from './AlarmList.vue'
import _ from 'lodash'

export default {
  // 體檢卡
  name: 'HealthCheck',
  mixins: [mixins],
  components: {
    HorizontalTimeline,
    AlarmList
  },
  data() {
    return {
      indicator: undefined, // 健康指數
      // 用水指標
      alarmBox: {
        goodDaysInThisMonth: undefined, // 本月正常運轉天數
        goodDaysInLastMonth: undefined, // 上月正常運轉天數
        alarmsInThisMonth: undefined, // 本月異常警示次數
        alarmsInLastMonth: undefined, // 上月異常警示次數
      },
      // 用水分析
      analysis: {
        mountedDays: undefined, // 水表安裝使用天數
        alarms: undefined, // 累計異常次數
        topAlarmType: undefined, // 最常發生異常類型
        topAlarms: undefined, // 最常發生異常類型的異常案件數量
        savedVolume: undefined // 異常案件平均節水量（噸）
      },

      // 查詢 異常案件類型列表
      // EndDate取目前時間的隔天，這樣才會包含今天的資料
      dateRange: [this.$moment().subtract(3, 'year').format('YYYY-MM-DD'), this.$moment().add(1 , 'day').format('YYYY-MM-DD')],

      queryAlarmHistory: {
        start: this.$moment().subtract(3, 'year').format('YYYY-MM-DD'),
        end: this.$moment().add(1 , 'day').format('YYYY-MM-DD') // EndDate取目前時間的隔天，這樣才會包含今天的資料
      },

      alarmProfile: undefined, // 異常案件歷程 for 時間軸
      alarmCount: 0,
      alarmDetail: undefined, // 指定異常案件內容 for 下方圖表與資訊
      alarmLatestLog: {
        notifyTargets: [] // 指定異常案件 最近一次 處理歷程 for 下方圖表與資訊 
      },
      suggestionList: [], // 建議方案列表 by categoryId

      // 趨勢圖表
      chartDataExist: false, // 是否有圖表資料
      xAxisData: [], // x軸 日期時間
      flowLine: [],
    };
  },
  computed: {
    currentProfile() {
      return JSON.parse(localStorage.getItem('currentProfile'))
    },
    indicatorChart() {
      let _this = this
      // 健康指數
      // 修改為四捨五入至小數點後第一位,20230620
      const _indicator = (_this.indicator * 100).toFixed(1)
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b} <br/> <b> {c} </b> 分<br/>",
          textStyle: {
            fontSize: 13,
            color: "#000000"
          }
        },
        series: [
          {
            name: "Indicator",
            type: "gauge",
            center: ["50%", "50%"],
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            splitNumber: 1,
            splitLine: {
              distance: -55,
              lineStyle: {
                width: 0
              }
            },
            radius: "100%",
            title: {
              show: false
            },
            itemStyle: {
              color: undefined
            },
            progress: {
              show: true,
              width: 10
            },
            detail: {
              valueAnimation: true,
              formatter: "{value} 分",
              offsetCenter: [0, "35%"],
              fontSize: 20,
              fontWeight: "bolder",
              color: "auto"
            },
            data: [
              {
                value: _indicator,  // 修改為四捨五入至小數點後第一位,20230620
                name: '健康指數'
              }
            ],
            axisLine: {
              show: true,
              lineStyle: {
                width: 10,
              }
            },
            pointer: {
              show: true,
              width: 3,
              length: "55%"
            },
            axisLabel: {
              show: true,
              fontWeight: "bold"
            },
            axisTick: {
              show: false
            }
          }
        ]
      }
      return option
    },
    trendChart() {
      let _this = this 
      let option = {
        tooltip:{
          trigger: 'axis',
          formatter: function(params) {
            return `<b>訊號時間:</b> ${params[0].data.recordedOn.substring(11,19)} <br/>
                    <p style="color: #4791DC; margin: 0"><b>瞬間值:</b> ${params[0].data.flow.toFixed(4)} (m³/h) </p>`
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: _this.xAxisData
        },
        yAxis: {
          type: 'value',
          name: '流量(m³/h)'
        },   
        dataZoom: [
          {   
            type: 'inside', 
            start: 10,      
            end: 60      
          }
        ],
        series: [
          {
            data: _this.flowLine,
            type: 'line',
            name: '瞬間流量',
            lineStyle: {
              color: '#4791DC'
            },
            symbol: 'none'
          }
        ]
      }
      return option
    },
    // 畫面顯示的健康指數 
    displayIndicator() {
      return (this.indicator * 100).toFixed(1)
    }

  },
  watch: {
    dateRange: function(val) {
      if (val) {
        this.queryAlarmHistory.start = val[0]
        this.queryAlarmHistory.end = val[1]
      } else {
        this.queryAlarmHistory.start = undefined
        this.queryAlarmHistory.end = undefined
      }
    },
  },
  async created(){
    if (this.currentProfile) {
      this.getHealthData() // 取得基本統計資訊
      this.getAlarmProfile() // 取得異常案件類型列表
    }
  },
  mounted() {
    // if (this.currentProfile) {
    //   this.getHealthData() // 取得基本統計資訊
    //   this.getAlarmProfile() // 取得異常案件類型列表
    // }
  },
  methods: {
    getHealthData() {
      this.axios.get('/api/report/profile/' + this.currentProfile.waterId + '/health').then(res => {
        // console.log('res', res)
        let data = res.data
        if (data) {
          this.indicator = data.indicator // 健康指數
          this.alarmBox.goodDaysInThisMonth = data.goodDaysInThisMonth // 本月正常運轉天數
          this.alarmBox.goodDaysInLastMonth = data.goodDaysInLastMonth // 上月正常運轉天數
          this.alarmBox.alarmsInThisMonth = data.alarmsInThisMonth // 本月異常警示次數
          this.alarmBox.alarmsInLastMonth = data.alarmsInLastMonth // 上月異常警示次數
          this.analysis.mountedDays = data.mountedDays // 水表安裝使用天數
          this.analysis.alarms = data.alarms // 累計異常次數
          this.analysis.topAlarmType =  data.topAlarmType // 最常發生異常類型
          this.analysis.topAlarms = data.topAlarms // 最常發生異常類型的異常案件數量
          this.analysis.savedVolume = data.savedVolume // 異常案件平均節水量（噸）
        }
      })
    },
    getAlarmProfile() {
      this.axios.get('/api/report/profile/' + this.currentProfile.waterId + '/alarm', {params: this.queryAlarmHistory}).then(res => {
        // console.log('getAlarmProfile', res)
        // let temp = _.cloneDeep(res.data);  //使用 lodash.cloneDeep
        // let test = temp.concat(temp).concat(temp).concat(temp).concat(temp).concat(temp).concat(temp).concat(temp).concat(temp)
        // this.alarmProfile = test
        this.alarmProfile = res.data

        // 異常病例發生次數
        if(this.alarmProfile && _.isArray(this.alarmProfile)) {
          this.alarmCount = this.alarmProfile.length
        }
      })
      // 檢查確保 ref 存在，防止首次載入的錯誤訊息
      if (this.$refs.alarmListRef && this.$refs.alarmListRef.getAlarmProfile) {
        this.$refs.alarmListRef.getAlarmProfile() // 更新異常案件列表
      }
    },
    // 取得案件內容
    async getAlarmDetail(id) {
      // console.log('click alarm', id)
      await this.axios.get('/api/report/profile/alarm', {params: {id: id}}).then(res => {
        // console.log('getAlarmDetail', res)
        this.alarmDetail = res.data.content[0]
      })
      // this.alarmLatestLog = await this.getAlarmLatestLogByAlarmId(32) // 依 alarmId 查詢 處理歷程
      this.alarmLatestLog = await this.getAlarmLatestLogByAlarmId(this.alarmDetail.id) // 依 alarmId 查詢 處理歷程
      this.suggestionList = await this.getAlarmSuggestionList(this.alarmDetail.type.categoryId) // 依 異常群組 取得 建議方案列表

      await this.$store.dispatch("getAlarmResult") // 取得 處理結果列表
     
      // console.log('alarmLatestLog', this.alarmLatestLog)
      this.getTrendChart() // 畫趨勢圖
    },
    // 依 alarmId 查詢 處理歷程
    async getAlarmLatestLogByAlarmId(id) {
      return this.axios.get('/api/report/profile/alarm/'+ id + '/log').then(res => {
        return res.data[res.data.length-1]
      })
    },
    // 取得 建議方案 中文名稱
    getAlarmSuggestionName(ids) {
      if (ids && this.suggestionList) {
        let temp = []
        ids.forEach(id => {
          if (this.suggestionList.filter(d => d.id == id)[0]) {
            temp.push(this.suggestionList.filter(d => d.id == id)[0].name)
          } else {
            temp.push(id + '(代碼尚未設定)')
          }
        });
        return temp
      }
    },
    // 取得 處理結果 中文名稱
    getAlarmResultName(ids) {
      if (ids) {
        let temp = []
        ids.forEach(id => {
          if (this.$store.state.alarmResultList.filter(d => d.id == id)[0]) {
            temp.push(this.$store.state.alarmResultList.filter(d => d.id == id)[0].name)
          } else {
            temp.push(id + '(代碼尚未設定)')
          }
        });
        return temp
      }
    },
    async getTrendChart() {
      if (this.currentProfile && this.alarmDetail) {
        let queryTrend = {
          start: this.parseDateTime(this.alarmDetail.openedOn),
          end: undefined
        }
        if (this.alarmDetail.closedOn == null) {
          queryTrend.end = this.getNDaysAfter(7, this.alarmDetail.openedOn)
        } else {
          queryTrend.end = this.parseDateTime(this.alarmDetail.closedOn)
        }
        // {params: {start: '2022-03-21', end: '2022-03-29'}}
        let datetime = []
        let flowList = []
        await this.axios.get('/api/report/profile/' + this.currentProfile.waterId + '/rawdata', {params: queryTrend}).then(res => {
          // console.log('getTrendChart', res)
          if (res.data.length > 0) {
            this.chartDataExist = true // 圖表資料存在
            let data = res.data
            data.forEach(element => {
              let formatedTime = this.parseDateTimeToHHMMSS(element.recordedOn) // 紀錄日期格式化
              datetime.push(formatedTime)
              // 瞬間流量
              flowList.push({
                recordedOn: formatedTime,
                volume: element.volumeAdjusted ? element.volumeAdjusted: element.volume, // 若有人工調整指針 則呈現人工調整後的值
                flow: element.flow,
                average: element.average,
                standardDeviation: element.standardDeviation,
                value: element.flow // value 決定線的值
              })
            })
          } else {
            this.chartDataExist = false // 無圖表資料
          }
        })
        if (this.chartDataExist) { // 圖表資料存在
          this.xAxisData = datetime // 圖表x軸
          this.flowLine = flowList
        }
        // console.log(this.xAxisData, this.flowLine)
      }

    }, 
    resetData() {
      this.dateRange = [this.$moment().subtract(3, 'year').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')],
      this.queryAlarmHistory = {
        start: this.$moment().subtract(3, 'year').format('YYYY-MM-DD'),
        end: this.$moment().add(1 , 'day').format('YYYY-MM-DD') // EndDate取目前時間的隔天，這樣才會包含今天的資料
      }
      this.alarmDetail = undefined
      this.alarmLatestLog = {
        notifyTargets: []
      }
    },
    // 匯出
    handleExport() {
      const url = '/api/report/profile/' + this.currentProfile.waterId + '/alarm/export'
      this.axios({
        method: "get",
        url: url,
        responseType: "blob", // 設置 responseType 為 'blob'，以處理二進制檔案數據
        params: this.queryAlarmHistory
      }).then((response) => {
        console.log(response)
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a")
        link.href = downloadUrl
        const fileName = `profile-alarm.ods`
        link.setAttribute("download", fileName) // 設置下載檔案的名稱和副檔名
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.$message({
          showClose: true,
          message: '匯出成功',
          type: 'success',
          duration: 3000
        })
      })
      .catch((error) => {
        console.error("Error:", error);
        this.$message({
          message: '匯出失敗',
          type: 'error'
        })
      });
    }
  }
}
</script>
